import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { DoubleListBoxViewThemed } from './double-list-box-view';

// TODO: wrap to HOC, make it something like withHandler(component)
export default class DataSource extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }

  // TODO: treat data without category as a whole category so we can reuse the code
  updateData = (add, category, names) => {
    this.setState((prevState) => {
      const dataCopy = [...prevState.data];
      if (category >= 0) {
        const categoryData = dataCopy[category].data.selected;
        if (names != null) {
          if (add) {
            // Select single item
            dataCopy[category].data.selected = _.uniq(categoryData.concat(names));
          } else {
            // Remove single item
            dataCopy[category].data.selected = _.difference(categoryData, names);
          }
        } else if (add) {
          // Select all items in category
          dataCopy[category].data.selected = _.difference(
            dataCopy[category].data.items,
            dataCopy[category].data.disabled
          );
        } else {
          // Remove all items in category
          dataCopy[category].data.selected = [];
        }
      } else {
        // Remove all items
        dataCopy.map((categoryObject, index) => {
          dataCopy[index].data.selected = [];
          return dataCopy;
        });
      }
      return { data: dataCopy };
    });
  }

  render() {
    return (
      <DoubleListBoxViewThemed
        data={this.state.data}
        onChange={this.updateData}
        i18n={this.props.i18n}
      />
    );
  }
}

DataSource.propTypes = {
  /**
   * Data passed down (do not modify directly)
   * Holds an array of 'category objects,' described below
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    data: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
      selected: PropTypes.arrayOf(PropTypes.string),
      disabled: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
